import { request } from "../../apis";

export const apiGetLanguageList = (): any =>
  request("get", `/api/language/list`, null, true);
